const HomePageActionTypes = {
  // ------------------------- Put user data into the store ----------------
  UPDATE_TO_ROOT: "UPDATE_TO_ROOT",

  // ------------------------- Delete piecce of data in the resume page ----------------
  DELETE_QUALIFICATION: "DELETE_QUALIFICATION",
  DELETE_PROFESSIONAL_DEVELOPMENT: "DELETE_PROFESSIONAL_DEVELOPMENT",
  DELETE_PROFESSIONAL_EXPERIENCE: "DELETE_PROFESSIONAL_EXPERIENCE",
  DELETE_REFEREE_CHECK: "DELETE_REFEREE_CHECK",
  DELETE_NON_TEACHING_EXPERIENCE: "DELETE_NON_TEACHING_EXPERIENCE",

  DELETE_VET_TRAINING_QUALIFICATION: "DELETE_VET_TRAINING_QUALIFICATION",
  DELETE_VET_INDUSTRY_QUALIFICATION: "DELETE_VET_INDUSTRY_QUALIFICATION",
  DELETE_VET_PROFESSIONAL_DEVELOPMENT: "DELETE_VET_PROFESSIONAL_DEVELOPMENT",
  DELETE_VET_TRAINING_EXPERIENCE: "DELETE_VET_TRAINING_EXPERIENCE",
  DELETE_VET_INDUSTRY_EXPERIENCE: "DELETE_VET_INDUSTRY_EXPERIENCE",
  DELETE_VET_TRAINER_MATRIX: "DELETE_VET_TRAINER_MATRIX",

  // ------------------------- Edit or add piecce of data in the resume page ----------------
  UPDATE_QUALIFICATION: "UPDATE_QUALIFICATION",
  UPDATE_PROFESSIONAL_DEVELOPMENT: "UPDATE_PROFESSIONAL_DEVELOPMENT",
  UPDATE_PROFESSIONAL_EXPERIENCE: "UPDATE_PROFESSIONAL_EXPERIENCE",
  UPDATE_REFEREE_CHECK: "UPDATE_REFEREE_CHECK",
  UPDATE_NON_TEACHING_EXPERIENCE: "UPDATE_NON_TEACHING_EXPERIENCE",

  // ------------------------- Add Can_deliver in the profile page ----------------
  ADD_CAN_DELIVER: "ADD_CAN_DELIVER",

  // ------------------------- Personal Details ----------------
  UPDATE_PERSONAL_DETAILS: "UPDATE_PERSONAL_DETAILS",

  // --------------------------Availability
  UPDATE_AVAILABILITY: "UPDATE_AVAILABILITY",

  UPDATE_VET_TRAINING_QUALIFICATION: "UPDATE_VET_TRAINING_QUALIFICATION",
  UPDATE_VET_INDUSTRY_QUALIFICATION: "UPDATE_VET_INDUSTRY_QUALIFICATION",
  UPDATE_VET_PROFESSIONAL_DEVELOPMENT: "UPDATE_VET_PROFESSIONAL_DEVELOPMENT",
  UPDATE_VET_TRAINING_EXPERIENCE: "UPDATE_VET_TRAINING_EXPERIENCE",
  UPDATE_VET_INDUSTRY_EXPERIENCE: "UPDATE_VET_INDUSTRY_EXPERIENCE",
  UPDATE_VET_TRAINER_MATRIX: "UPDATE_VET_TRAINER_MATRIX",

  // -------------------------- Job Board
  APPLY_TO_LISTING: "APPLY_TO_LISTING",
  ADD_FAVOURITE_LISTING: "ADD_FAVOURITE_LISTING",
  REMOVE_FAVOURITE_LISTING: "REMOVE_FAVOURITE_LISTING",
  // --------------------------- Add Deliver in Admin

  ADD_CAN_DELIVER_ADMIN: "ADD_CAN_DELIVER_ADMIN",
  SAVE_SHARE_PROFILE_TEACHER_ID: "SAVE_SHARE_PROFILE_TEACHER_ID",

  UPDATE_SIMPLE_QUALIFICATION: "UPDATE_SIMPLE_QUALIFICATION"
}

export default HomePageActionTypes
